import React from 'react';

const HGError = ({ errorMessage }) => {
    return (
        <div className="my-3 flex w-full flex-col items-center justify-center rounded bg-red-500 p-2">
            <p variant="h6" className="text-white">
                {errorMessage}
            </p>
        </div>
    );
};

export default HGError;
